export default __webpack_public_path__ + "static/media/startBag.a6cc7f80.png";